import { CheckIcon } from '@chakra-ui/icons';
import { Box, Circle, Heading, HStack, Progress, Skeleton, Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useMeQuery } from '../../generated/graphql';

import './Dashboard.css';

export interface User {
    name: string;
}

export interface IChecklistItem {
    text: string;
    completed: boolean;
    hasLoaded: boolean;
    hide: boolean;
}

export default function Checklist() {
    const [checklist, setChecklist] = useState<IChecklistItem[]>([]);
    const [percentage, setPercentage] = useState<number>(0);
    const { loading, error, data: userData } = useMeQuery();

    useEffect(() => {
        setChecklist([
            {
                text: 'Create a Profile',
                completed: Boolean(userData?.me?.profile?.id),
                hasLoaded: !loading,
                hide: false
            },
            {
                text: 'Choose a Career Path',
                completed: Boolean(userData?.me?.careerPathId),
                hasLoaded: !loading,
                hide: false
            },
            {
                text: 'Upload an Elevator Pitch',
                completed: Boolean(userData?.me?.cloudflare_video_id) || Boolean(userData?.me?.profile?.elevator_pitch_url),
                hasLoaded: !loading,
                hide: false
            },
            {
                text: 'Apply for a job',
                completed: Boolean(userData?.me?.applications?.length),
                hasLoaded: !loading,
                hide: false
            }
        ]);
    }, [loading, userData]);

    useEffect(() => {
        let numCompleted = 0;
        let numTasks = 0;
        checklist.forEach((task) => {
            if (!task.hide) {
                if (task.completed) {
                    numCompleted++;
                }
                numTasks++;
            }
            setPercentage(Math.round((numCompleted / numTasks) * 100));
        });
    }, [checklist]);

    return (
        <Box className="boxContent">
            <Heading as="h3" className="checklistHeading" fontSize={{ base: '20px' }} mb="16px">
                Getting Started Checklist
            </Heading>
            <div className="progressBarWrapper">
                {percentage !== 100 ? (
                    <span className="progressBarValue" style={{ left: percentage + 1 + '%' }}>
                        {percentage + '%'}
                    </span>
                ) : (
                    ''
                )}
                {percentage === 100 ? (
                    <span className="progressBarCompleteValue" style={{ right: '12px' }}>
                        {percentage + '%'}
                    </span>
                ) : (
                    ''
                )}
                <Progress
                    value={percentage}
                    colorScheme="brand"
                    height="20px"
                    borderRadius="xl"
                    backgroundColor="midnight.15"
                    mb="24px"
                />
            </div>
            {checklist.map((task) => {
                return !task.hide ? (
                    <Skeleton isLoaded={task.hasLoaded} key={task.text}>
                        <Box borderRadius="8px" mt="4">
                            <HStack>
                                <Circle
                                    size="24px"
                                    border={
                                        task.completed
                                            ? '#48E56F'
                                            : '1px solid var(--chakra-colors-midnight-100)'
                                    }
                                    background={task.completed ? '#48E56F' : 'white'}
                                >
                                    {task.completed ? (
                                        <CheckIcon w={'14px'} h={'14px'} color="white" />
                                    ) : (
                                        ''
                                    )}
                                </Circle>
                                <Text
                                    className={
                                        task.completed ? 'checklistText-checked' : 'checklistText'
                                    }
                                >
                                    {task.text}
                                </Text>
                            </HStack>
                        </Box>
                    </Skeleton>
                ) : (
                    ''
                );
            })}
        </Box>
    );
}
